export enum TypeDialogEnum {
    FORM = 'form',
    CONFIRM = 'confirm',
    ERROR = 'error',
    INFO = 'info'
}